/**
 * Keeps the iOS Share Extension able to write to Firestore by sharing the signed-in user's
 * Firebase refresh token into the shared Keychain.
 *
 * The app authenticates via the Firebase JS SDK (skipNativeAuth: true), so there's no native
 * Auth session for the extension to read — instead we hand it the refresh token, which it
 * exchanges for a fresh ID token at share time. Synced on every auth-state change; cleared on
 * logout or anonymous (so the extension never writes to the wrong/old account). No-op on web
 * and Android (Android opens the app directly and has no separate extension process).
 */

import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import ShareReceiver from '../plugins/ShareReceiver';
import { useAuth } from '../context/AuthContext';

export function useShareCredentialSync() {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const refreshToken = currentUser?.refreshToken;
    if (currentUser && !currentUser.isAnonymous && refreshToken) {
      ShareReceiver.setShareCredentials({ refreshToken }).catch(() => {});
    } else {
      ShareReceiver.clearShareCredentials().catch(() => {});
    }
  }, [currentUser?.uid, currentUser?.isAnonymous, currentUser?.refreshToken]);
}
